import Vue from "vue";
import Component from "vue-class-component";
import TheMainFooter from "./components/TheMainFooter/TheMainFooter.vue";
import TheModalState from "./components/TheModalState/TheModalState.vue";
import TheToolbarContainer from "./components/TheToolbar/TheToolbarContainer.vue";
import TheBottomNav from "./components/TheBottomNav/TheBottomNav.vue";

@Component({
  name: 'App',
  components: {
    TheMainFooter,
    TheModalState,
    TheToolbarContainer,
    TheBottomNav
  },
})
export default class App extends Vue { }